import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  externalContacts: null,
  externalContactsStatus: IDLE,

  createExternalContactStatus: IDLE,
  updateExternalContactStatus: IDLE,
  deleteExternalContactStatus: IDLE
};

const externalContactsSlice = createSlice({
  name: 'externalContacts',
  initialState,
  reducers: {
    getExternalContacts(state) {
      state.externalContactsStatus = LOADING;
    },
    getExternalContactsSucceeded(state, action) {
      state.externalContactsStatus = SUCCEEDED;
      state.externalContacts = action.payload;
    },
    getExternalContactsFailed(state) {
      state.externalContactsStatus = FAILED;
    },

    createExternalContact(state) {
      state.createExternalContactStatus = LOADING;
    },
    createExternalContactSucceeded(state) {
      state.createExternalContactStatus = SUCCEEDED;
    },
    createExternalContactFailed(state) {
      state.createExternalContactStatus = FAILED;
    },

    updateExternalContact(state) {
      state.updateExternalContactStatus = LOADING;
    },
    updateExternalContactSucceeded(state) {
      state.updateExternalContactStatus = SUCCEEDED;
    },
    updateExternalContactFailed(state) {
      state.updateExternalContactStatus = FAILED;
    },

    deleteExternalContact(state) {
      state.deleteExternalContactStatus = LOADING;
    },
    deleteExternalContactSucceeded(state) {
      state.deleteExternalContactStatus = SUCCEEDED;
    },
    deleteExternalContactFailed(state) {
      state.deleteExternalContactStatus = FAILED;
    }
  }
});

export const {
  getExternalContacts,
  getExternalContactsSucceeded,
  getExternalContactsFailed,
  createExternalContact,
  createExternalContactSucceeded,
  createExternalContactFailed,
  updateExternalContact,
  updateExternalContactSucceeded,
  updateExternalContactFailed,
  deleteExternalContact,
  deleteExternalContactSucceeded,
  deleteExternalContactFailed
} = externalContactsSlice.actions;

export default externalContactsSlice.reducer;
